module.exports = __webpack_public_path__ + "media/pop_sound.6b8b8d31.mp3";